import { render, staticRenderFns } from "./AdditionalTariff.vue?vue&type=template&id=49a86276&scoped=true"
import script from "./AdditionalTariff.vue?vue&type=script&lang=js"
export * from "./AdditionalTariff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a86276",
  null
  
)

export default component.exports